import VehicleComparisonVehicleData from "./VehicleComparisonVehicleData";

export default VehicleComparisonVehicleData;
